import capitalize from "capitalize";
import handleUserConfigurations from "./handleUserConfigurations";
import getStudyAlerts from "../Auth/getStudyAlerts";
const handleInitialization = (
    employees,
    employees_who_have_appointments,
    clinics,
    rooms,
    appointment_assignable_employees,
    appointment_assignable_employees_all,
    provinces,
    cities,
    patient_status,
    relationship_to_patient,
    studies,
    user_configurations,
    existing_allergies,
    studies_ottawa,
    studies_montreal,
    source_categories,
    msgroups_app_sh_ip_prep_employees,
    msgroups_app_sh_onleave_employees,
    file_categories,
    file_subcategories,
    file_subcategories_all,
    waitlist_categories,
    waitlist_subcategories,
    waitlist_subcategories_all,
) => {
    handle_clinics(clinics);
    handle_employees(employees);
    handle_employees_who_have_appointments(employees_who_have_appointments);
    handle_patients();
    handle_appointments();
    handle_rooms(rooms);
    handle_appointment_assignable_employees(
        appointment_assignable_employees,
        appointment_assignable_employees_all,
    );
    handle_phone_pre_evaluation();
    handle_initial_evaluation();
    handle_provinces(provinces);
    handle_cities(cities);
    handlePatientStatusChoices(patient_status);
    handleRelationshipToPatientChoices(relationship_to_patient);
    handleStudies(studies, studies_ottawa, studies_montreal);
    handleUserConfigurations(
        user_configurations,
        appointment_assignable_employees,
        clinics,
    );
    handleExistingAllergies(existing_allergies);
    handleSourceCategories(source_categories);
    handleMsgroupsAppShIpPrepEmployees(msgroups_app_sh_ip_prep_employees);
    handleMsgroupsAppShOnLeaveEmployees(msgroups_app_sh_onleave_employees);
    handleMSGroupArray(appointment_assignable_employees);
    handleFileCategories(
        file_categories,
        file_subcategories,
        file_subcategories_all,
    );
    handleWaitlistCategories(
        waitlist_categories,
        waitlist_subcategories,
        waitlist_subcategories_all,
    );
    getStudyAlerts(false, () => {});
};
export const handle_employees = (employees) => {
    const activeEmployees = employees.filter((employee) => employee.active);
    localStorage.activeEmployees = JSON.stringify(activeEmployees);
    localStorage.employees = JSON.stringify(employees);
    localStorage.voidEmployee = JSON.stringify({
        uuid: "00000000-0000-0000-0000-000000000000",
        first_name: "Void",
        last_name: "Employee",
        email: "void@void.com",
        active: true,
        position: "Void Position",
        title: "Void Title",
    });
};
export const handle_employees_who_have_appointments = (
    employees_who_have_appointments,
) => {
    localStorage.employees_who_have_appointments = JSON.stringify(
        employees_who_have_appointments,
    );
};
export const handle_clinics = (clinics) => {
    localStorage.clinics = JSON.stringify(clinics);
    localStorage.clinicsOptions = JSON.stringify(
        clinics.map((clinic) => [
            clinic.uuid,
            capitalize.words(clinic?.name || ""),
        ]),
    );
};
export const handle_patients = () => {
    localStorage.voidPatient = JSON.stringify({
        uuid: "00000000-0000-0000-0000-000000000000",
        first_name: "Void",
        last_name: "Patient",
        email: "void@void.com",
        phones: [],
        gender: "",
        city: "",
        province: "",
        birth_date: "",
        age: "",
        preferred_language: "",
    });
    localStorage.voidCreateNewPatient = JSON.stringify({
        active: "",
        birth_date: "",
        chart_number: "",
        city: "",
        deceased_date: "",
        education_level: "",
        email: "",
        ethnicity: "",
        extraction_of_anonymous_information: true,
        race: "",
        race_other: "",
        first_name: "",
        gender: "",
        health_card_expiration_date: "",
        health_care_number: "",
        last_name: "",
        middle_name: "",
        licence_plate_number: "",
        name_of_resident_professional: "",
        name_of_treating_professional: "",
        non_potential_studies: "",
        number_of_child: "",
        occupation: "",
        person_to_contact_for_appointment: "",
        person_to_contact_for_appointment_details: "",
        phones: [],
        postal_code: "",
        potential: "",
        potential_date: "",
        preferred_communication_method: "",
        preferred_language: "",
        preferred_name: "",
        primary_clinic: "",
        primary_contact_email: "",
        primary_contact_first_name: "",
        primary_contact_last_name: "",
        primary_contact_relationship: "",
        primary_contact_language: "",
        primary_contact_phone_numbers: [],
        province: "",
        referred_by: "",
        secondary_contact_email: "",
        secondary_contact_first_name: "",
        secondary_contact_last_name: "",
        secondary_contact_relationship: "",
        secondary_contact_language: "",
        secondary_contact_phone_numbers: [],
        sex: "",
        street_address: "",
        study_code: "",
        years_of_education: "",
    });
    localStorage.voidOnePatientInfo = JSON.stringify({
        uuid: "00000000-0000-0000-0000-000000000000",
        active: "",
        ad8: [],
        age: "",
        alerts: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                content_type: "patient",
                employee: JSON.parse(localStorage.voidEmployee),
                obj_reference: "00000000-0000-0000-0000-000000000000",
                value: "",
                active: true,
            },
        ],
        allergies: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                allergy: "00000000-0000-0000-0000-000000000000",
                name: "",
                type: "",
                date_of_onset: "",
                last_reaction_date: "",
                details_of_reaction: "",
            },
        ],
        alternate_paragraphs: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                clinic: "",
                date: "",
                administration_method: "",
                immediate_recall: "",
                delayed_recall: "",
                denominator: "",
            },
        ],
        apoe: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                date: "",
                clinic: "",
                result: "",
                administration_method: "",
            },
        ],
        appointments: [],
        birth_date: "",
        cdr: [],
        chart_number: "",
        city: "",
        creation_date: "",
        data_collection_state: [],
        deceased_date: "",
        deleted_surgeries: [],
        dossier_cmo: "",
        education_level: "",
        email: "",
        ethnicity: "",
        extraction_of_anonymous_information: "",
        race: "",
        race_other: "",
        family_doctor: {
            name: "",
            clinic_name: "",
            address: "",
            phone_number: "",
            fax_number: "",
        },
        family_history: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                creation_date: "",
                last_update: "",
                start_date: "",
                end_date: "",
                self_reported: true,
                is_ongoing: false,
                problem: "",
                category: "",
                details: "",
                relationship: "",
                additional_info: {},
            },
        ],
        file_sync_info: "",
        files: [],
        files_sync: "",
        first_name: "",
        gender: "",
        health_card_expiration_date: "",
        health_care_number: "",
        intake_forms: [],
        iqcode: [],
        islt: [],
        last_name: "",
        latitude: "",
        licence_plate_number: "",
        longitude: "",
        medesync_profile_code: "",
        medical_problems: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                creation_date: "",
                last_update: "",
                start_date: "",
                end_date: "",
                self_reported: true,
                is_ongoing: false,
                problem: "",
                category: "",
                details: "",
                relationship: "",
                additional_info: {},
                treatments: [],
                patient_medications: [],
                surgeries: [],
            },
        ],
        medications: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                creation_date: "",
                last_update: "",
                start_date: {
                    year: "",
                    month: "",
                    day: "",
                },
                end_date: {
                    year: "",
                    month: "",
                    day: "",
                },
                administration_route: "",
                other_administration_route: "",
                form: "",
                dosage: "",
                dosage_unit: "",
                other_dosage_unit: "",
                is_ongoing: false,
                dose_frequency: {
                    times: "",
                    every: "",
                    frequency: "",
                },
                medication: {
                    uuid: "00000000-0000-0000-0000-000000000000",
                    brand: "",
                    din: "",
                    forms: [""],
                    name_en: "",
                    name_fr: "",
                },
            },
        ],
        memory_concerns: [
            {
                concern: "",
                date: {
                    year: "",
                    month: "",
                    day: "",
                },
                reason: "",
                progression: "",
                type_of_decline: "",
                affects_daily_activities: false,
            },
        ],
        middle_name: "",
        mmse: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                appointment: "",
                clinic: "",
                date: "",
                employee: JSON.parse(localStorage.voidEmployee),
                patient: JSON.parse(localStorage.voidPatient),
                patient_study_profile: "",
                score_numerator: "",
            },
        ],
        moca: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                appointment: "",
                clinic: "",
                date: "",
                employee: JSON.parse(localStorage.voidEmployee),
                patient: JSON.parse(localStorage.voidPatient),
                patient_study_profile: "",
                score_numerator: "",
                score_denominator: "",
            },
        ],
        name_of_resident_professional: "",
        name_of_treating_professional: "",
        non_potential_studies: "",
        notes: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                content_type: "patient",
                employee: JSON.parse(localStorage.voidEmployee),
                obj_reference: "00000000-0000-0000-0000-000000000000",
                value: "",
            },
        ],
        number_of_child: "",
        occupation: "",
        patient_sources: [
            {
                category: "",
                details: "",
            },
        ],
        person_to_contact_for_appointment: "",
        person_to_contact_for_appointment_details: "",
        pharmacy: {
            name: "",
            address: "",
            phone_number: "",
            fax_number: "",
        },
        phones: [],
        postal_code: "",
        potential: "",
        potential_date: "",
        preferred_communication_method: "",
        preferred_language: "",
        preferred_name: "",
        primary_clinic: "",
        primary_contact_email: "",
        primary_contact_first_name: "",
        primary_contact_last_name: "",
        primary_contact_relationship: "",
        primary_contact_language: "",
        primary_contact_phone_numbers: [],
        province: "",
        rbans: [],
        referred_by: "",
        reminder_date: "",
        secondary_contact_email: "",
        secondary_contact_first_name: "",
        secondary_contact_last_name: "",
        secondary_contact_relationship: "",
        secondary_contact_language: "",
        secondary_contact_phone_numbers: [],
        sex: "",
        status: "",
        street_address: "",
        studies: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                date: "",
                study: "",
                status: "",
            },
        ],
        study_code: "",
        surgeries: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                date: "",
                details: "",
                self_reported: false,
                hospital: "",
                name: "",
            },
        ],
        treatments: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                creation_date: "",
                last_update: "",
                start_date: "",
                end_date: "",
                treatment: "",
                indication: "",
                course_completed: false,
                inactive: false,
                inactive_reason: "",
                dose_frequency: {
                    times: "",
                    every: "",
                    frequency: "",
                },
                administration_route: "",
                other_administration_route: "",
                dosage: "",
                dosage_unit: "",
                other_dosage_unit: "",
            },
        ],
        vitals: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                appointment: "",
                clinic: "",
                creatinine: "",
                date: "",
                diastolic_pressure: "",
                employee: JSON.parse(localStorage.voidEmployee),
                patient: JSON.parse(localStorage.voidPatient),
                patient_study_profile: "",
                glucose_mmol_per_l: "",
                heart_rate: "",
                oxygen_level: "",
                respiration_rate: "",
                systolic_pressure: "",
                temperature_c: "",
                waist_circumference_cm: "",
                weight_kg: "",
                height_cm: "",
                bmi: "",
            },
        ],
        waitlists: [
            {
                uuid: "00000000-0000-0000-0000-000000000000",
                waiting_since: "1900-01-01",
                waitlist: {
                    uuid: "00000000-0000-0000-0000-000000000000",
                    name: "Void Waitlist",
                },
                patient: JSON.parse(localStorage.voidPatient),
                recall_date: "1900-01-01",
                assignee: JSON.parse(localStorage.voidEmployee),
                employee: JSON.parse(localStorage.voidEmployee),
                status: "",
                outcome: "",
                person_to_contact_for_appointment: "",
                number_of_days: 0,
                note: "",
            },
        ],
        years_of_education: "",
    });
};
export const handle_appointments = () => {
    localStorage.voidAppointment = JSON.stringify({
        startDate: "",
        endDate: "",
        title: "Void Appointment",
        id: "00000000-0000-0000-0000-000000000000",
        medesync_id: "123123123",
        creation_date: "",
        cancellation_datetime: "",
        cancellation_note: "",
        cancellation_type: "",
        appointment_type: "",
        appointment_status: "to_confirm",
        patient: JSON.parse(localStorage.voidPatient),
        patient_study_profile: "",
        clinic: "",
        appointment_creator: JSON.parse(localStorage.voidEmployee),
        room: "",
        employees_uuids: ["00000000-0000-0000-0000-000000000000"],
        employees: [JSON.parse(localStorage.voidEmployee)],
        notes: [],
        chain: "",
        study: "",
        visit: "",
        administered_way: "",
        last_update: "",
        details: "",
    });
};
export const handle_rooms = (rooms) => {
    localStorage.rooms = JSON.stringify(rooms);
    localStorage.roomsOptions = JSON.stringify(
        rooms.map((room) => [room.uuid, capitalize.words(room?.alias || "")]),
    );
    localStorage.roomsUUIDs = JSON.stringify(rooms.map((room) => room.uuid));
    localStorage.ottawaRoomsOptions = JSON.stringify(
        rooms
            .filter((room) => room.clinic.name === "ottawa")
            .map((room) => [room.uuid, capitalize.words(room?.alias || "")]),
    );
    localStorage.montrealRoomsOptions = JSON.stringify(
        rooms
            .filter((room) => room.clinic.name === "montreal")
            .map((room) => [room.uuid, capitalize.words(room?.alias || "")]),
    );
};
export const handle_appointment_assignable_employees = (
    appointment_assignable_employees,
    appointment_assignable_employees_all,
) => {
    localStorage.appointment_assignable_employees = JSON.stringify(
        appointment_assignable_employees,
    );
    localStorage.appointment_assignable_employees_all = JSON.stringify(
        appointment_assignable_employees_all,
    );
};
export const handle_phone_pre_evaluation = () => {
    localStorage.voidPhonePreEvaluation = JSON.stringify({
        uuid: "00000000-0000-0000-0000-000000000000",
        creation_date: "",
        patient: JSON.parse(localStorage.voidPatient),
        employee: JSON.parse(localStorage.voidEmployee),
        type: "phone-pre-evaluation",
        form: {
            version: "PPE.0.7.20260505",
            versionDescription: `Remove reasonOfTheConsultation.`,
            isStillInterested: "notDecidedYet",
            notInterestedReason: "",
            notInterestedDate: "",
            isHaveSpareTime: "notDecidedYet",
            isRescheduleSucceed: "notDecidedYet",
            isIntact: "yes",
            consentToCollectData: "notDecidedYet",
            doYouHaveACardiacPaceMaker: "notDecidedYet",
            yesHaveACardiacPaceMakerAndSoOn: [],
            mandatoryTutorshipOrPowerOfAttorney: {
                isYes: "notDecidedYet",
                details: "",
            },
            wouldYouBeInterestedInParticipatingInClinicalResearch:
                "notDecidedYet",
            consent2AccessOrRequestMedicalHistory: {
                isYes: "notDecidedYet",
                OHIPNumber: "",
                RAMQNumber: "",
                other: "",
            },
            doYouHaveAdditionalInformation: "notDecidedYet",
            additionalInformation: [],
            areYouComfortableUsingCertainTechnologicalTools: {
                areYouComfortableUsingCertainTechnologicalTools:
                    "notDecidedYet",
                couldSomeoneAroundYouAssistYou: "notDecidedYet",
                yesSomeoneAroundYouAssistYou: "",
            },
            howWouldYouPreferToHaveYourInitialAssessment: "",
            scheduleAnIntake: "notDecidedYet",
        },
    });
};
export const handle_initial_evaluation = () => {
    localStorage.voidInitialEvaluation = JSON.stringify({
        uuid: "00000000-0000-0000-0000-000000000000",
        creation_date: "",
        patient: JSON.parse(localStorage.voidPatient),
        employee: JSON.parse(localStorage.voidEmployee),
        type: "initial-evaluation",
        form: {
            version: "IE.0.15.20260713",
            versionDescription: `Transform lifeHabits.isVisitInPerson and lifeHabits.measure`,
            isIntact: "yes",
            howIsTheVisitConducted: "",
            informationAndConsentForms: {
                initialEvaluationInformationAndConsentForm: "",
                consent2DataTransfer: "",
                caregiverConsent: "",
                ApoEConsent: "",
            },
            demographicInformation: {
                yearsOfEducation: "",
                educationLevel: "",
                highestGradeOfEducation: "",
                lastOccupation: "",
                currentEmploymentStatus: "",
                otherEmploymentStatus: "",
                dateOfRetirement: {
                    year: "",
                    month: "",
                    day: "",
                },
                numberOfChildren: "",
                maritalStatus: "",
                otherMaritalStatus: "",
                currentLivingSituation: [],
                otherCurrentLivingSituation: "",
                housingSituation: "",
                otherHousingSituation: "",
                ethnicity: "",
                race: "",
                otherRace: "",
                doYouConsiderYourself2BeASnowbird: "",
                doYouHavePrivateHealthInsurance: "",
            },
            situation: {
                haveYouBeenHospitalizedInTheLastYear: {
                    isYes: "notDecidedYet",
                    whenWereYouAdmitted: {
                        year: "",
                        month: "",
                        day: "",
                    },
                    whichHospitalWereYouIn: "",
                    howLongDidYouStay: "",
                    howLongDidYouStayTimeUnit: "",
                    additionalInformation: "",
                },
                haveYouEverParticipatedInAClinicalTrial: {
                    isYes: "notDecidedYet",
                    records: [],
                },
            },
            lifeHabits: {
                sleep: {
                    hoursOfSleep: "",
                },
                hoursOfPhysicalActivity: "",
                hoursOfSocialization: "",
                describeYourDiet: "",
                alcohol: {
                    isAlcohol: "notDecidedYet",
                    endDateAsAFormerConsumer: {
                        year: "",
                        month: "",
                        day: "",
                    },
                    currentConsumer: {
                        beers: {
                            amount: "",
                            frequency: "",
                        },
                        wine: {
                            amount: "",
                            frequency: "",
                        },
                        spirits: {
                            amount: "",
                            frequency: "",
                        },
                        total: "",
                        isASubstanceAbuse: "notDecidedYet",
                    },
                },
                tobaccoOrNicotine: {
                    isTobaccoOrNicotine: "notDecidedYet",
                    endDateAsAFormerConsumer: {
                        year: "",
                        month: "",
                        day: "",
                    },
                    currentConsumer: [],
                },
                recreationalDrugUsage: {
                    isRecreationalDrugUsage: "notDecidedYet",
                    records: [],
                    isASubstanceAbuse: "notDecidedYet",
                },
                DAST: [],
            },
            cognitionMoodAndBehavior: {
                mood: [],
                behavior: [],
            },
        },
    });
};
export const handle_provinces = (provinces) => {
    localStorage.provinces = JSON.stringify(provinces);
    localStorage.provincesSimplifiedArray = JSON.stringify(
        provinces.map((province) => province.choice),
    );
    localStorage.provincesOptions = JSON.stringify(
        provinces.map((province) => [province.choice, province.representation]),
    );
};
export const handle_cities = (cities) => {
    localStorage.cities = JSON.stringify(cities);
    let citiesSimplified = {};
    for (const province in cities) {
        citiesSimplified[province] = cities[province].map(
            (city) => city.choice,
        );
    }
    localStorage.citiesSimplifiedArray = JSON.stringify(citiesSimplified);
    let citiesOptions = {};
    for (const province in cities) {
        citiesOptions[province] = cities[province].map((city) => [
            city.choice,
            city.representation,
        ]);
    }
    localStorage.citiesOptions = JSON.stringify(citiesOptions);
};
export const handlePatientStatusChoices = (choices) => {
    localStorage.patientStatusChoices = JSON.stringify(choices);
    localStorage.patientStatusChoicesSimplifiedArray = JSON.stringify(
        choices.map((choice) => choice.choice),
    );
    localStorage.patientStatusChoicesOptions = JSON.stringify(
        choices.map((choice) => [choice.choice, choice.representation]),
    );
};
export const handleRelationshipToPatientChoices = (choices) => {
    localStorage.relationshipToPatientChoices = JSON.stringify(choices);
    localStorage.relationshipToPatientChoicesSimplifiedArray = JSON.stringify(
        choices.map((choice) => choice.choice),
    );
    localStorage.relationshipToPatientChoicesOptions = JSON.stringify(
        choices.map((choice) => [choice.choice, choice.representation]),
    );
};
export const handleStudies = (studies, studies_ottawa, studies_montreal) => {
    localStorage.studies = JSON.stringify(studies);
    localStorage.studies_ottawa = JSON.stringify(studies_ottawa);
    localStorage.studies_montreal = JSON.stringify(studies_montreal);
};
export const handleExistingAllergies = (existing_allergies) => {
    localStorage.existing_allergies = JSON.stringify(existing_allergies);
    localStorage.existing_allergiesOptions = JSON.stringify(
        existing_allergies.map((allergy) => [allergy.uuid, allergy.name]),
    );
};
export const handleSourceCategories = (source_categories) => {
    localStorage.source_categories = JSON.stringify(source_categories);
    localStorage.source_categoriesOptions_EN = JSON.stringify(
        source_categories.map((source_category) => [
            source_category.uuid,
            source_category.name_en,
        ]),
    );
    localStorage.source_categoriesOptions_FR = JSON.stringify(
        source_categories.map((source_category) => [
            source_category.uuid,
            source_category.name_fr,
        ]),
    );
};
export const handleMsgroupsAppShIpPrepEmployees = (
    msgroups_app_sh_ip_prep_employees,
) => {
    localStorage.msgroups_app_sh_ip_prep_employees = JSON.stringify(
        msgroups_app_sh_ip_prep_employees,
    );
};
export const handleMSGroupArray = (appointment_assignable_employees) => {
    let groups = [];
    let group_objects = [];
    appointment_assignable_employees.forEach((employee) => {
        const ms_group_id = employee?.ms_group_id;
        if (!groups.includes(ms_group_id)) {
            groups.push(ms_group_id);
            group_objects.push({
                ms_group_id: ms_group_id,
                ms_group_name: employee?.ms_group_name,
            });
        }
    });
    localStorage.ms_group_array = JSON.stringify([
        ...groups,
        "00000000-0000-0000-0000-000000000000",
    ]);
    localStorage.ms_group_objects = JSON.stringify([
        ...group_objects,
        {
            ms_group_id: "00000000-0000-0000-0000-000000000000",
            ms_group_name: "Void MS Group",
        },
    ]);
};
export const handleMsgroupsAppShOnLeaveEmployees = (
    msgroups_app_sh_onleave_employees,
) => {
    localStorage.msgroups_app_sh_onleave_employees = JSON.stringify(
        msgroups_app_sh_onleave_employees,
    );
};
export const handleFileCategories = (
    file_categories,
    file_subcategories,
    file_subcategories_all,
) => {
    localStorage.file_categories = JSON.stringify(file_categories);
    localStorage.file_subcategories = JSON.stringify(file_subcategories);
    localStorage.file_subcategories_all = JSON.stringify(
        file_subcategories_all,
    );
};
export const handleWaitlistCategories = (
    waitlist_categories,
    waitlist_subcategories,
    waitlist_subcategories_all,
) => {
    localStorage.waitlist_categories = JSON.stringify(waitlist_categories);
    localStorage.waitlist_subcategories = JSON.stringify(
        waitlist_subcategories,
    );
    localStorage.waitlist_subcategories_all = JSON.stringify(
        waitlist_subcategories_all,
    );
};
export default handleInitialization;
